'use client';
import { ButtonOutline } from '@snack-uikit/button';
import { ArrowUpSVG } from '@snack-uikit/icons';
import cn from 'classnames';
import { MutableRefObject, useEffect, useState } from 'react';

import s from './styles.module.scss';
import { handleScrollToTop, isScrollOffsetMoreThanScreenHeight } from './utils';

export function ScrollToTop({ layoutWrapperRef }: { layoutWrapperRef: MutableRefObject<HTMLDivElement | null> }) {
  const [visible, setVisible] = useState(isScrollOffsetMoreThanScreenHeight(layoutWrapperRef.current?.scrollTop));

  const makeToggleVisibility = () => {
    return (event: Event) => {
      const target = event.target as HTMLDivElement | null;
      const shouldBeVisible = isScrollOffsetMoreThanScreenHeight(target?.scrollTop);
      return setVisible(shouldBeVisible);
    };
  };

  useEffect(() => {
    const refCurrent = layoutWrapperRef.current;
    if (refCurrent) {
      const toggleVisibility = makeToggleVisibility();
      refCurrent.addEventListener('scroll', toggleVisibility);

      return () => refCurrent.removeEventListener('scroll', toggleVisibility);
    }
  }, [layoutWrapperRef.current]);

  return (
    // <ArrowUpSVG
    //   onClick={() => handleScrollToTop(layoutWrapperRef.current)}
    //   className={cn(s.icon_up, {
    //     [s.hide]: !visible,
    //   })}
    // />

    <ButtonOutline
      onClick={() => handleScrollToTop(layoutWrapperRef.current)}
      className={cn(s.icon_up, {
        [s.hide]: !visible,
      })}
      icon={<ArrowUpSVG />}
      appearance='neutral'
      size='m'
    />
  );
}
